import React from 'react';
import classNames from 'classnames';

import './FormSection.scss';

interface IProps {
  children?: React.ReactNode;
  sectionAddition?: React.ReactNode;
  sectionName?: string;
  sectionDescription?: string;
  lastSection?: boolean;
}

export const FormSection = ({
  children,
  sectionAddition,
  sectionName,
  sectionDescription,
  lastSection,
}: IProps) => (
  <div className={classNames('FormSection', { lastSection })}>
    <div className="FormSectionInfo">
      <div className="left-content">
        <div className="FormSectionName d-flex">{sectionName}</div>
        <div className="FormSectionDescription d-flex">{sectionDescription}</div>
      </div>
      {!!sectionAddition && <div className="right-content">{sectionAddition}</div>}
    </div>
    {children}
  </div>
);

FormSection.defaultProps = {
  children: undefined,
  sectionAddition: undefined,
  sectionName: undefined,
  sectionDescription: undefined,
  lastSection: undefined,
};
